import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ObjectMediaContainer, ObjectMediaType} from '../../core/definitions/object-media-container';
import {objectTypeToMatSymbol} from "../../shared/material-icons";
import {MediaSegment} from "../../core/definitions/media-segment";
import {msToTimecode} from '../../object-edit/edit-field-timecode/timecode.utils';

@Component({
  selector: 'app-thumbnail-stack',
  templateUrl: './thumbnail-stack.component.html',
  styleUrls: ['./thumbnail-stack.component.scss'],
  standalone: false
})
export class ThumbnailStackComponent {
  invalidSrc = {};
  @Input() mediaContainer: ObjectMediaContainer;
  @Input() mediaType: ObjectMediaType;
  @Input() isEditing: boolean;
  @Input() imageGallery;
  @Input() rootObject: any;
  @Output() setActiveImg = new EventEmitter<object>();
  @Output() setActiveSegment = new EventEmitter<{ index: number, segment: MediaSegment }>();

  setMedia(index) {
    const mediaIndex = {
      index: index
    };
    this.setActiveImg.emit(mediaIndex);
  }

  setInvalidSrc(index) {
    this.invalidSrc[index] = true;
  }

  setSegment(index: number, segment: MediaSegment) {
    this.setActiveSegment.emit({index, segment});
  }

  getMaterialSymbol(objectType: string) {
    return objectTypeToMatSymbol(objectType);
  }

  tileClasses(index: number, segment?: MediaSegment) {
    return {
      'thumbnail-stack__inner--selected': segment
        ? segment.segmentId === this.mediaContainer.currentSegmentId
        : (index === this.mediaType.currentMediaIndex &&
          this.mediaType.mediaType === this.mediaContainer.currentMediaType.mediaType),
      'thumbnail-stack__inner--segment-selected': !segment && !!this.mediaContainer.currentSegmentId
    };
  }

  protected readonly msToTimecode = msToTimecode;
}
